import { captureException } from '@sentry/vue';

const AUTHENTICATION_ERRORS_MESSAGE_REGEXP = /(\(|": )(401|403)(\s|$)/;

const STALE_CHUNK_ERRORS_MESSAGE_REGEXPS = [
  /Failed to fetch dynamically imported module/,
  /Importing a module script failed/,
  /error loading dynamically imported module/,
];

const WEBVIEW_INJECTED_SCRIPT_ERRORS_REGEXPS = [
  /Can't find variable: (M|EmptyRanges)\b/,
];

const CLIENT_CONNECTIVITY_ERRORS_REGEXPS = [/auth\/network-request-failed/];

export const IGNORED_SENTRY_ERRORS = [
  AUTHENTICATION_ERRORS_MESSAGE_REGEXP,
  ...STALE_CHUNK_ERRORS_MESSAGE_REGEXPS,
  ...WEBVIEW_INJECTED_SCRIPT_ERRORS_REGEXPS,
  ...CLIENT_CONNECTIVITY_ERRORS_REGEXPS,
];

export const DENIED_SENTRY_URLS = [/cookielaw\.org/, /onetrust\.com/];

const NETWORK_ABORT_ERRORS_REGEXPS = [
  /<no response>/,
  /Load failed/,
  /Failed to fetch/i,
  /NetworkError when attempting to fetch resource/,
];

export const isNetworkAbortError = (err: unknown): boolean => {
  const message = err instanceof Error ? err.message : String(err);
  return NETWORK_ABORT_ERRORS_REGEXPS.some((regexp) => regexp.test(message));
};

export const captureHandledError = (
  err: unknown,
  tags: { feature: string },
): void => {
  if (isNetworkAbortError(err)) {
    return;
  }

  captureException(err, { level: 'warning', tags });
};
